import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  Divider,
  Stack,
} from "@mui/material";
import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  transition: "0.3s",
  "&:hover": {
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  },
}));

const CurrentMonitoring = ({
  data,
  setUpMonitor,
  onAddNewMonitor,
  onEditMonitoring,
  onViewDetails,
}) => {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          No Active Monitoring
        </Typography>
      </Box>
    );
  }

  const handleViewDetails = (details) => {
    onViewDetails(details);
  };

  const handleSetupMonitoring = (id) => {
    // Implement setup monitoring functionality
    setUpMonitor(id);
  };

  const handleEditMonitoring = (details) => {
    onEditMonitoring(details);
    console.log(details);
  };

  return (
    <Box sx={{ maxWidth: "lg", mx: "auto", p: 2, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Current Monitoring
      </Typography>
      <List>
        {data.map((item, index) => (
          <React.Fragment key={index}>
            <StyledCard>
              <CardContent>
                {item.monitoringDetails ? (
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                    <Stack sx={{ flex: { sm: 2 } }}>
                      <List dense>
                        <ListItem>
                          <ListItemText
                            primary="Name"
                            secondary={item.monitoringDetails.name}
                          />
                        </ListItem>

                        <ListItem>
                          <ListItemText
                            primary="Active Until"
                            secondary={item.monitoring.expiration}
                          />
                        </ListItem>
                      </List>
                    </Stack>
                    <Stack
                      sx={{
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleViewDetails(item.monitoringDetails)
                          }
                          sx={{ flex: 1 }}
                        >
                          View Details
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          startIcon={<EditIcon />}
                          onClick={() =>
                            handleEditMonitoring(item.monitoringDetails)
                          }
                          sx={{ flex: 1 }}
                        >
                          Edit
                        </Button>
                      </Box>
                    </Stack>
                  </Stack>
                ) : (
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="body1" gutterBottom>
                      Monitoring activated but not set up
                    </Typography>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleSetupMonitoring(item.monitoring.id)}
                    >
                      Setup Monitoring
                    </Button>
                  </Box>
                )}
              </CardContent>
            </StyledCard>
            {index < data.length - 1 && <Divider sx={{ my: 2 }} />}
          </React.Fragment>
        ))}
      </List>
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Button variant="contained" color="primary" onClick={onAddNewMonitor}>
          Add New Monitor
        </Button>
      </Box>
    </Box>
  );
};

export default CurrentMonitoring;
